// Carte grise animée, affichée à la place d'une prédication pendant son chargement.
export default function PredicationCardSkeleton() {
  return (
    <div
      aria-hidden="true"
      className="h-full flex flex-col bg-white rounded-2xl overflow-hidden ring-1 ring-cmp-navy/6 animate-pulse"
    >
      <div className="aspect-video bg-cmp-navy/10" />
      <div className="p-4 space-y-2">
        <div className="h-3.5 bg-cmp-navy/10 rounded w-4/5" />
        <div className="h-3 bg-cmp-navy/5 rounded w-3/5" />
        <div className="h-8 bg-cmp-navy/5 rounded-full mt-4" />
      </div>
    </div>
  )
}
